import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlugCircleMinus } from '@fortawesome/pro-regular-svg-icons';

import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

import { GoogleGrant } from 'components/nylas/v3/grant/google';
import { MicrosoftGrant } from 'components/nylas/v3/grant/microsoft';

import type { Grant, GrantPaths } from 'components/nylas/v3/types';

interface Props {
  nylas: {
    grant: Grant | null;
    paths: GrantPaths;
  };
}

export default function CrmIntegrationSettings({ nylas }: Props) {
  const [nylasGrant, setNylasGrant] = useState(nylas.grant);

  const grantProps = {
    grant: nylasGrant,
    paths: nylas.paths,
    onDestroy: () => setNylasGrant(null),
  };

  return (
    <div className="d-flex flex-column gap-3">
      <h6>Connected Providers</h6>

      {!nylasGrant && <>
        <Empty className="bg-white" variant="inline">
          <Empty.Media>
            <FontAwesomeIcon icon={faPlugCircleMinus} />
          </Empty.Media>
          <Empty.Content>
            <Empty.Title>No Providers Connected</Empty.Title>
            To automatically log emails as CRM Activities, connect an email provider from the list below.
            You can only connect one account at a time.
          </Empty.Content>
        </Empty>

        <h6>Available Providers</h6>
      </>}

      <div className="d-flex flex-column gap-3">
        {(!nylasGrant || nylasGrant.providerName === 'google') &&
          <GoogleGrant {...grantProps} />
        }
        {(!nylasGrant || nylasGrant.providerName === 'microsoft') &&
          <MicrosoftGrant {...grantProps} />
        }
      </div>
    </div>
  );
}
